import { TabbedSelectOption } from '../../../resources/js/components/TabbedSelect/TabbedSelect';
import React, { ReactNode } from 'react';
import { LinkProps } from 'next/link';
import LinkWrapper from '../LinkWrapper/LinkWrapper';

export type TabbedSelectLinkOptionWrapperProps = {
  option: TabbedSelectOption;
  children: ReactNode;
} & Partial<LinkProps>;

export default function TabbedSelectLinkOptionWrapper({
  option,
  children,
  ...rest
}: TabbedSelectLinkOptionWrapperProps): JSX.Element {
  if (option.url) {
    return (
      <LinkWrapper {...rest} href={option.url} scroll={false}>
        {children}
      </LinkWrapper>
    );
  }

  return <>{children}</>;
}
